import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  impersonationAlertShown = new BehaviorSubject<boolean>(false);
}
